import React, { useState, useEffect } from "react";
import axios from "axios";
import { FaHospitalSymbol, FaSearch, FaStar } from "react-icons/fa";
import Navbar from "./Navbar";
import {API_URL,FAST_API_URL} from "../api"

const SearchHospitals = () => {
  const [searchTerm, setSearchTerm] = useState("");
  const [recommendations, setRecommendations] = useState([]);
  const [loading, setLoading] = useState(false);
  const [location, setLocation] = useState({ latitude: null, longitude: null });

  // Automatically get geolocation on mount
  useEffect(() => {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(
        (position) => {
          const { latitude, longitude } = position.coords;
          console.log(latitude, longitude)
          setLocation({ latitude, longitude });
        },
        (error) => {
          console.error("Error getting location:", error);
          alert("Please allow location access to find hospitals near you.");
        }
      );
    } else {
      alert("Geolocation is not supported by this browser.");
    }
  }, []);

  const handleSearch = async () => {
    if (!searchTerm.trim()) return;

    setLoading(true);
    try {
      console.log(location.latitude)
      const response = await axios.post(
        `${API_URL}/recommend`, // Update with your backend endpoint
        {

          query: searchTerm.trim(),
          user_latitude: 28.6130,
          user_longitude: 77.2095
        }
      );
      setRecommendations(response.data.results);
    } catch (error) {
      console.error(error);
      alert("An error occurred. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-cyan-100 via-white to-blue-200 py-6 px-4 flex flex-col items-center">
      <Navbar />
      <h1 className="text-3xl font-bold text-blue-800 mt-6 mb-4 text-center drop-shadow-lg">
        🏥 Hospital Finder
      </h1>


      <div className="w-full max-w-xl flex flex-col sm:flex-row gap-4 mb-8">
        <input
          type="text"
          placeholder="Search for a procedure (e.g., knee replacement)"
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
          className="flex-1 px-5 py-3 rounded-full border border-blue-300 shadow focus:outline-none focus:ring-2 focus:ring-blue-500 bg-white placeholder-gray-400"
        />
        <button
          onClick={handleSearch}
          className="bg-gradient-to-r from-blue-600 to-blue-800 hover:from-blue-700 hover:to-blue-900 text-white px-6 py-3 rounded-full flex items-center gap-2 shadow-lg transform hover:scale-105 transition-all duration-300 ease-in-out"
        >
          <FaSearch />
          Search
        </button>
      </div>

      {loading && (
        <div className="text-blue-700 font-semibold mb-4 animate-pulse">
          Loading recommendations...
        </div>
      )}

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 w-full max-w-6xl">
        {recommendations.map((hospital, index) => (
          <div
            key={index}
            className="bg-white rounded-3xl shadow-xl border border-blue-100 p-6 flex flex-col justify-between hover:scale-105 transform transition-transform duration-300"
          >
            <div className="flex items-center gap-3 mb-3">
              <div className="bg-blue-100 p-2 rounded-full">
                <FaHospitalSymbol className="text-blue-700 w-6 h-6" />
              </div>
              <h2 className="text-xl font-semibold text-blue-800">
                {hospital.name}
              </h2>
            </div>
            <div className="flex-1 space-y-2">
              <p className="text-gray-600 text-sm">
                💰 <span className="font-medium">Price:</span>{" "}
                ₹{hospital.price.toLocaleString()}
              </p>
              <p className="text-gray-600 text-sm">
                📍 <span className="font-medium">Distance:</span>{" "}
                {hospital.distance_km} km
              </p>
              <p className="text-blue-600 text-sm">
                🛡️ <span className="font-medium">TPA:</span> {hospital.TPA}
              </p>
              <p className="text-yellow-600 text-sm flex items-center gap-1">
                <FaStar /> {hospital.rating} / 5
              </p>
            </div>
          </div>
        ))}
      </div>

      {!loading && recommendations.length === 0 && (
        <p className="text-gray-500 mt-4 text-center">
          Enter a procedure to find the best nearby hospitals!
        </p>
      )}
    </div>
  );
};

export default SearchHospitals;
